var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":"","id":"banner-do-aluno"}},[_c('v-responsive',{attrs:{"aspect-ratio":16 / 10}},[_c('div',{staticClass:"foto-do-banner"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }